import React from "react";

import SubscribeForm from "components/SubscribeForm";
import Icon from "components/Icon";

import { Wrapper, SocialLinks, EmailLink } from "./styles";

const HeroSocials = ({ content }) => {
  return (
    <Wrapper>
      <EmailLink to="mailto:press@clearmatics.com">
        press@clearmatics.com
      </EmailLink>
      <SocialLinks>
        <a
          href="https://gitter.im/clearmatics"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon icon="gitter" title="Clearmatics on Gitter" />
        </a>
        <a
          href="https://twitter.com/clearmatics"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon icon="twitter" title="Clearmatics on Twitter" />
        </a>
        <a
          href="https://www.linkedin.com/company/clearmatics"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon icon="linkedin" title="Clearmatics on LinkedIn" />
        </a>
        {/* <a
          href="https://instagram.com/clearmatics"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon icon="instagram" title="Clearmatics on Instagram" />
        </a> */}
        <a
          href="https://medium.com/clearmatics"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon icon="medium" title="Clearmatics on Medium" />
        </a>
        <a
          href="https://github.com/clearmatics"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon icon="github" title="Clearmatics on Github" />
        </a>
        <a
          href="https://facebook.com/clearmatics"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon icon="facebook" title="Clearmatics on Facebook" />
        </a>
      </SocialLinks>
      <SubscribeForm maxWidth="450px" />
    </Wrapper>
  );
};

export default HeroSocials;
